import type { ReelMotionTuning } from "@slot/mechanics-reels";

// Per-game reel motion VALUES. Shape comes from mechanics/reels/public.
// Tunable — starting defaults (scroll + stop).
export const REEL_MOTION_TUNING: ReelMotionTuning = {
  bonusMode: { speedMultiplier: 1.5 }, // declared, not wired: the reels mechanic does not read it yet
  spin: {
    spinUpDurationSeconds: 0.2,
    scrollSpeedRowsPerSecond: 18,
    minSpinDurationSeconds: 0.4,
    // Turbo/super_turbo base spin length (before the ÷2.25 / ÷4 clock scale).
    // 0.4 → ~0.18s real in turbo: noticeably snappier than a sped-up normal spin.
    turboMinSpinDurationSeconds: 0.4,
    reelStartStaggerSeconds: 0.06,
    // Anticipation wind-up (normal mode): each reel pulls up ~22px over 0.12s
    // before dropping into the spin. (A small bottom-edge gap shows during the
    // pull — accepted.)
    windUpPixels: 10,
    windUpSeconds: 0.11,
    // Soft launch off the rest line + soft top, vs the default "quadOut" yank.
    windUpEasing: "quadInOut",
  },
  stop: {
    // 6 frames @ 60 fps.
    reelStopStaggerSeconds: 0.17,
    // Brake over the last ~150 px onto the landing (tune to taste — roughly one
    // cell). The reel cruises, then decelerates this distance to a stop.
    brakeDistancePixels: 150,
    bounce: { enable: true, pixels: 30, durationSeconds: 0.1, easing: "backOut" }, // easing declared, not wired
  },
  // Server-flagged anticipation: a near-miss reel slows + spins an extra beat before it
  // stops. Starting defaults — tune in playtest. (Stage 1 = motion; frame + sound = Stage 2.)
  anticipation: {
    slowVelocityMultiplier: 0.4, // quarter speed during the beat
    durationSeconds: 2, // total slow beat before the reel commits its stop
    turboDurationSeconds: 0.5, // shorter in turbo/super_turbo
    rampInSeconds: 0.4, // ramp v→antV at the start (the "catch")
    crispFillers: true, // render the slowed reel crisp (readable) during the beat
    startDelaySeconds: 0.2, // held breath before the FIRST anticipated reel's beat (after prev lands)
    // Grid ZOOM during the tease: layoutRoot creeps up while any flagged reel teases (continuous
    // creep — a longer tease zooms more, capped), then snaps back fast when the last one lands.
    scale: {
      creepPerSecond: 0.01, // +2%/s zoom while anticipating
      maxScale: 1.1, // cap at 110% of resting scale
      downStartDelaySeconds: 0.15, // hold at peak this long after the last land, then drop
      downSeconds: 0.12, // fast snap-back on the last land
    },
  },
  // Spin-roll loop SFX (no fades). spinSoundId loops for the whole spin (start when
  // the reels scroll, stop on the last land); anticipationSoundId loops during the
  // tease and ducks the spin roll to anticipationDuckScale underneath it.
  roll: {
    spinSoundId: "reel_roll",
    anticipationSoundId: "reel_anticipation_roll",
    anticipationDuckScale: 0.3, // spin roll at 30% under the tease — tune in playtest
  },
};
